export const colorMain = '#3f51b5';